var React = require('react');

function VideoPause (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"16","width":"8","height":"36","rx":"2","fill":"currentColor","key":0}),React.createElement("rect",{"width":"8","height":"36","rx":"2","fill":"currentColor","key":1})]);
}

VideoPause.defaultProps = {"width":"24","height":"36","viewBox":"0 0 24 36","fill":"none"};

module.exports = VideoPause;

VideoPause.default = VideoPause;
